import { Badge, Box, Tab, Tabs } from '@mui/material'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { LoadsheetTable } from './LoadsheetValidationTable'
import './Loadsheet.css'
import LoadsheetDataMetaInformation from './LoadsheetDataMetaInformation'
import { notification } from 'antd'
import { getUUID } from 'utils/utils'
// import NotificationComponent from 'components/common/NotifiactionComponent'

type ILoadsheetSetupFile = {
  validationData: any
  columnData: any
  file: any
}

export default function LoadsheetValidation({
  validationData,
  columnData,
  file,
}: ILoadsheetSetupFile) {
  const [value, setValue] = useState<any>(Object.keys(validationData ?? {})?.[0])
  const [dataKey, setDataKey] = useState<string[]>([])
  const [tableData, setTableData] = useState<any>({})
  const [columns, setColumns] = useState<any[]>([])
  const activeKeys = useRef<string[]>([])

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }
  useEffect(() => {
    if (validationData?.[value]) {
      setTableData(validationData?.[value] || {})
      setColumns(columnData?.[value])
    }
  }, [value])

  useEffect(() => {
    setDataKey(Object.keys(validationData ?? {}))
    setTableData(validationData?.[value] || {})
    setColumns(columnData?.[value])
  }, [])

  const notify = useCallback(() => {
    const notifications = validationData?.[value]?.notifications || []

    notifications.forEach((notif: any) => {
      const key = getUUID(12) // unique key for this notification
      activeKeys.current.push(key)
      notification.warning({
        key,
        message: notif.message,
        description: notif.description,
        duration: 0,
        style: {
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          maxWidth: '700px',
        },
      })
    })
  }, [validationData, value])

  useEffect(() => {
    notify()
    return () => {
      activeKeys.current.forEach((key) => notification.destroy(key))
      activeKeys.current = []
    }
  }, [notify])

  return (
    <>
      <Box sx={{ maxWidth: '100%', bgcolor: 'background.paper' }}>
        {dataKey.length > 1 && (
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="loadsheet-validation-sheet-data"
            sx={{ padding: 2 }}
          >
            {dataKey?.map((key: any, index: number) => {
              return (
                <Tab
                  key={key}
                  value={key}
                  label={
                    <Badge
                      className="loadsheet-tab-badge"
                      badgeContent={validationData?.[key]?.total_invalid_rows}
                      variant="dot"
                      color="error"
                    >
                      {key}
                    </Badge>
                  }
                />
              )
            })}
          </Tabs>
        )}
      </Box>
      <Box padding={2}>
        {Object.keys(tableData)?.length > 0 && (
          <LoadsheetDataMetaInformation
            file={file}
            fileValidation={tableData || {}}
            loadsheetStatus={'failed'}
          />
        )}
      </Box>
      <Box>
        {tableData?.processed_data?.length > 0 && columns?.length > 0 && (
          <>
          <LoadsheetTable columns={columns} data={tableData?.processed_data} />
          </>
        )}
      </Box>
    </>
  )
}
